import React from 'react';
import logoUrl from '~/assets/images/logo-vitec-figlo.svg';

type PoweredByFilgoLogoProps = {};

const PoweredByFilgoLogo: React.FC<PoweredByFilgoLogoProps> = () => (
  <img
    src={logoUrl}
    className="w-[90px] h-[29px] md:w-[110px] md:h-[35px] mt-4"
    alt="Vitec Figlo"
  />
);

export default PoweredByFilgoLogo;